import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';

import {staticPagesFactory} from './static-pages.factory';

import PALETTE_SCHEMA from './static-pages.palette-schema.yaml';

class StaticPagesFeature extends AbstractVisualFeature {
    get name() {
        return 'StaticPages';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return staticPagesFactory(PALETTE);
    }
}

export const StaticPages = new StaticPagesFeature(allVisuals);
